/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, ViewContainerRef, TemplateRef, Inject } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'fm-tooltip-content',
  templateUrl: './tooltip.component.html'
})
export class TooltipComponent implements AfterViewInit {
  public eventPageX: number;
  public eventPageY: number;
  public top: string;
  public left: string;
  public contentWidth: number;
  public contentHeight: number;
  public template: TemplateRef<any>;

  @ViewChild('tooltipContainer')
  private readonly _tooltipContainer: ElementRef;

  @ViewChild('viewContainer', { read: ViewContainerRef })
  private readonly viewContainer: ViewContainerRef;

  constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  ngAfterViewInit(): void {
    if (this.template) {
      this.viewContainer.createEmbeddedView(this.template);
    }
    const { width, height } = this._tooltipContainer.nativeElement.getBoundingClientRect();
    this.contentWidth = width;
    this.contentHeight = height;
    this.setPosition(this.eventPageX, this.eventPageY);
    this._changeDetectorRef.detectChanges();
  }

  public setPosition(pageX: number, pageY: number): void {
    const left = pageX + this.contentWidth > this._document.defaultView.innerWidth ? pageX - this.contentWidth : pageX;
    const top =
      pageY + this.contentHeight > this._document.defaultView.innerHeight - this.contentHeight ? pageY - this.contentHeight - 64 : pageY;
    this.top = `${top + 32}px`;
    this.left = `${left}px`;
  }
}
